import React, { memo, useEffect } from 'react'
import { VtoImage } from '@luxottica/vto-image'
import { apiLog } from '../../../api/restApi'
import log from '../../../libs/log'
import Video from './VtoVideo'

interface Props {
  divId: string
  videoUrl?: string
  slideIndex: number
}

const VtoRender: React.FC<Props> = ({ divId, videoUrl, slideIndex }) => {
  useEffect(() => {
    if (videoUrl) return
    return () => {
      try {
        VtoImage.closeImage({
          divId: divId,
        })
          .then(() => log.info('unmounted render ' + divId))
          .catch(error => apiLog(error))
      } catch (e) {
        log.error(e)
      }
    }
  }, [divId, videoUrl])

  return videoUrl ? (
    <Video src={videoUrl} slideIndex={slideIndex} />
  ) : (
    <div id={divId} className="render image" />
  )
}

export default memo(VtoRender)
